import { FC } from 'react'
import classNames from 'classnames'

import { translate } from '../../../../helpers/translations/translator'
import Icon from '../../../style/Icon/Icon'

import './CollapseButton.scss'

interface CollapseButtonProps {
    isCollapsed: boolean;
    onClick: () => void;
    className?: string;
}

const CollapseButton: FC<CollapseButtonProps> = ({
    isCollapsed,
    onClick,
    className = '',
}) => {
    const buttonClassNames = classNames('button-collapse', {
        'button-collapse--is-collapsed': isCollapsed,
    }, className)

    return (
        <button
            type="button"
            onClick={onClick}
            className={buttonClassNames}
        >
            {translate(isCollapsed ? 'common.showLess' : 'common.showMore')}

            <Icon color="black" kind="keyboard_arrow_down" />
        </button>
    )
}

export default CollapseButton
